import { useEffect, useState } from "react";
import { localDateTime } from "../../lib/datetime";
import { useTranslation } from "react-i18next";
import { Inbox } from "lucide-react";
import { featureRequests } from "../../api/platform";
import { NeuCard } from "../../components/neu/Neu";

// طلبات التفعيل من الشركات، الأكثر طلباً أولاً — دليل تسعير الموديولات.
export const FeatureRequests = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    featureRequests().then(setData).catch(() => setData(null));
  }, []);

  if (!data) return null;

  return (
    <NeuCard data-testid="feature-requests-card">
      <div className="flex flex-wrap items-center gap-3">
        <Inbox className="h-5 w-5 text-primary" />
        <div>
          <h2 className="text-lg font-black">{t("features.requestsTitle")}</h2>
          <p className="text-xs text-muted-foreground">
            {data.total ? t("features.requestsSubtitle", { count: data.total }) : t("features.requestsEmpty")}
          </p>
        </div>
      </div>

      {data.rows.length ? (
        <div className="mt-4 grid gap-2">
          {data.rows.map((row) => (
            <div
              key={row.feature}
              className="flex flex-wrap items-center gap-3 rounded-2xl p-3 shadow-neu-in"
              data-testid={`feature-request-${row.feature}`}
            >
              <span className="min-w-0 flex-1 truncate text-xs font-bold">{t(`features.names.${row.feature}`, { defaultValue: row.feature })}</span>
              <span className="font-mono text-sm font-black text-primary" dir="ltr">{row.companies}</span>
              <span className="font-mono text-[11px] text-muted-foreground" dir="ltr">
                {localDateTime(row.last_at)}
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </NeuCard>
  );
};
